import { DataType } from '@/util/index'

const COLLECTION_SUMMARY = {
  section: {
    caption: 'COLLECTION SUMMARY',
    name: 'collection-summary',
    type: 'card',
    code: DataType.PrivilegeCode.LOAN_DETAILS_SECTION,
    speechCraftCode: 'PAYMENT_OPTION_DISCLOSURE',
    tooltipPosition: 'bottom'
  },
  title: [
    {
      label: 'Entry Date in Collection',
      template: 'collectedDate',
      class: 'text-grey f-s-25 p-l-30'
    },
    {
      label: 'Days in Collection',
      template: 'inCollectedDay',
      class: 'text-success f-s-25 p-l-30'
    }
  ],
  dialogWidth: '900px',
  sectionFields: [
    { label: 'Total Paid in Post-Origination', template: 'amount', format: 'currency', type: 2 },
    { label: 'Total Original in Collection', template: 'amount', format: 'currency', type: 100 },
    { label: 'Total Discount', template: 'amount', format: 'currency', type: 8 }
  ],
  formFields: [
    { label: 'Principal', template: 'principal', format: 'currency' },
    { label: 'Finance Fee', template: 'interest', format: 'currency' },
    { label: 'Late Fee', template: 'lateFee', format: 'currency' },
    { label: 'NSF Fee', template: 'nsfFee', format: 'currency' },
    { label: 'Unpaid Fee', template: 'unpaidFee', format: 'currency' },
    { label: 'Total', template: 'amount', format: 'currency' }
  ]
}
export default COLLECTION_SUMMARY
